import React, { useState } from 'react';

const SimpleNavTest: React.FC = () => {
  const [hoveredItem, setHoveredItem] = useState<string | null>(null);

  const testItems = [
    { name: 'Dashboards', subItems: ['Executive', 'Orders', 'Inventory'] },
    { name: 'Inventory', subItems: ['Stock Levels', 'Catalog'] },
    { name: 'Orders', subItems: ['Order Management'] }
  ];

  return (
    <div className="min-h-screen bg-gray-50 p-8">
      <div className="max-w-4xl mx-auto">
        <h1 className="text-3xl font-bold text-gray-900 mb-8">Simple Navigation Test</h1>
        
        <div className="bg-white rounded-lg shadow-lg p-6 mb-8">
          <h2 className="text-xl font-semibold mb-4">Current State</h2>
          <p className="text-gray-600">Hovered Item: <code className="bg-gray-100 px-2 py-1 rounded">{hoveredItem || 'None'}</code></p>
        </div>

        <div className="bg-white rounded-lg shadow-lg p-6">
          <h2 className="text-xl font-semibold mb-4">Test Navigation</h2>
          <div className="flex space-x-4">
            {testItems.map((item) => (
              <div 
                key={item.name}
                className="relative"
                onMouseEnter={() => {
                  console.log('Hovering over:', item.name);
                  setHoveredItem(item.name);
                }}
                onMouseLeave={() => {
                  console.log('Leaving:', item.name);
                  setHoveredItem(null);
                }}
              >
                <button className="px-4 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600 transition-colors">
                  {item.name}
                </button>
                
                {hoveredItem === item.name && (
                  <div className="absolute top-full left-0 mt-2 w-64 bg-white rounded-lg shadow-xl border border-gray-200 py-2 z-50">
                    {item.subItems.map((subItem) => (
                      <button
                        key={subItem}
                        onClick={() => {
                          console.log('Subitem clicked:', subItem);
                          alert(`Clicked: ${subItem}`);
                        }}
                        className="block w-full text-left px-4 py-3 hover:bg-gray-50 transition-colors"
                      >
                        {subItem}
                      </button>
                    ))}
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SimpleNavTest;
